import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './expansion-panel.component.html',
  styleUrl: './expansion-panel.component.scss'
})
export class ExpansionPanelComponent {
  @Input() title: string = 'Expansion Panel';
  @Input() isOpen: boolean = false;
  contentHeight: string = '0px';

  @ViewChild('headerContent') headerContent!: ElementRef;
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;

  ngAfterViewInit() {
    this.contentHeight = (this.contentWrapper.nativeElement.scrollHeight + 16) + 'px';
  }

  togglePanel(): void {
    this.isOpen = !this.isOpen;
  }
}
